export const mockData = {
  // 消息卡片标题
  title: '来自XX患者的企微群聊天记录',
  // 群ID
  chatId: 'wrU_xXCgAATu7ARBRsFZ8Kxt-5UC0SzQ',
  // 消息开始Seq
  startSeq: 10001,
  // 消息结束Seq
  endSeq: 10008,
  previewList: [
    {
      // 发送人名称
      senderName: 'XXX',
      // 发送人角色
      senderRole: 'PATIENT',
      // 消息类型
      msgType: 'text',
      // 文案
      content:
        '文字游戏记得记得就精装修几点能到呢坚决执行你电脑135451546464545545466467979797997979797',
      // 发送时间
      msgTime: 1778320993000
    },
    {
      senderName: 'XXX',
      senderRole: 'PATIENT',
      msgType: 'voice',
      content: "[语音] 9''",
      url: 'https://filetest4.drstrong.cn/chat/313344332464129/user/2243024/img/1/13a118c7042d49ccbe54dcf86f301181',
      msgTime: 1778321010000
    },
    {
      senderName: '智能医助',
      senderRole: 'ASSISTANT',
      msgType: 'image',
      content: '[图片]',
      url: 'https://filetest4.drstrong.cn/chat/313344332464129/user/2243024/img/1/1ee264a612724b009d2686ca99b1bfa7',
      msgTime: 1778321020000
    },
    {
      senderName: '智能医助',
      senderRole: 'ASSISTANT',
      msgType: 'video',
      content: '[视频]',
      url: 'https://filetest4.drstrong.cn/chat/313344332464129/user/2243024/video/1/64002cb81f4c447fbdd96b6a1b4078f3',
      msgTime: 1778321020000
    }
  ]
}
